export default [
  {
    project : "Feedback Loft",
    description : "Feedback Loft is a platform where music creators, graphic designers, artists, and creatives submit projects to have them reviewed by other users.",
    img : "https://github.com/julacosta9/FeedbackLoft-v2/raw/master/client/src/images/feedbackloft-logo-transparent.png",
    link : "https://gentle-savannah-15578.herokuapp.com/",
    repo: "https://github.com/julacosta9/FeedbackLoft-v2"
  },
  {
    project : "Chatticus",
    description : "Chatticus is a simple, session-based chat application built with Socket.io. Who needs friends when you can open multiple browser windows and chat with yourself!",
    img : "https://github.com/tyler-arthur/chatticus/raw/master/chatticus.png",
    link : "https://floating-dusk-63158.herokuapp.com/",
    repo : "https://github.com/tyler-arthur/chatticus"
  },
  {
    project : "Employee Generator",
    description : "This command line application dynamically generates a webpage with team members and their relavant information.",
    img : "https://github.com/tyler-arthur/Employee-Generator/raw/master/employee-generator.png",
    repo : "https://github.com/tyler-arthur/Employee-Generator"
  },
  
  // {
  //   project : "DnD Session Helper",
  //   description : "*WORK-IN-PROGRESS* This project was created to for Dungeons & Dragons 5th Edition players and game masters to track character sheets and have visible, live player stats that everyone can see.",
  //   img : "https://github.com/tarthurf/dnd-session-helper/raw/master/dnd-session-helper.png",
  //   link : "https://dnd-session-helper.herokuapp.com/",
  //   repo : "https://github.com/tarthurf/dnd-session-helper"
  // },
  // {
  //   project : "Password Generator",
  //   description : "A simple password generator. Built using JavaScript and Bootstrap.",
  //   img : "https://github.com/tarthurf/Secure_Password_Generator/raw/master/tarthurf.github.io_Secure_Password_Generator_.png?raw=true",
  //   link : "https://tarthurf.github.io/Secure_Password_Generator/",
  //   repo : "https://github.com/tarthurf/Secure_Password_Generator"
  // }
]
